module.exports = __webpack_public_path__ + "static/chart-f3d137007787d72fe609e21fc69fe387.jpg";